import withScriptjs from 'react-google-maps/lib/withScriptjs';
import withGoogleMap from 'react-google-maps/lib/withGoogleMap';
import PropTypes from 'prop-types';
import dynamic from 'next/dynamic';

const GoogleMap = dynamic(
  () => import(/* webpackChunkName: "googlemap" */ 'react-google-maps/lib/components/GoogleMap'),
  { ssr: false }
);
const Marker = dynamic(
  () => import(/* webpackChunkName: "googlemap" */ 'react-google-maps/lib/components/Marker'),
  { ssr: false }
);

const MyGoogleMap = ({ center, icon, marker, options, refFunc, zoom }) => (
  <GoogleMap center={center} options={options} ref={(ref) => refFunc(ref)} zoom={zoom}>
    {marker && <Marker position={marker} icon={icon} />}
  </GoogleMap>
);

MyGoogleMap.propTypes = {
  center: PropTypes.shape({
    lat: PropTypes.number.isRequired,
    lng: PropTypes.number.isRequired,
  }),
  icon: PropTypes.shape({
    scaledSize: PropTypes.shape({ height: PropTypes.number, width: PropTypes.number }),
    url: PropTypes.string,
  }),
  marker: PropTypes.shape({
    lat: PropTypes.number.isRequired,
    lng: PropTypes.number.isRequired,
  }),
  options: PropTypes.shape({}),
  refFunc: PropTypes.func,
  zoom: PropTypes.number,
};

MyGoogleMap.defaultProps = {
  center: { lat: 0, lng: 0 },
  marker: null,
  icon: undefined,
  options: {},
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  refFunc: () => {},
  zoom: 12,
};

export default withScriptjs(withGoogleMap(MyGoogleMap));
